<template>
  <PageBranchDetail :branch="branch"/>
</template>

<script>
import { get } from 'lodash'
import AppRouteMixin from '~/mixins/AppRouteMixin'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import PageBranchDetail from '@theme/components/content/PageBranchDetail'

const PAGE = {
  name: 'RouteBranchDetail',
  nuxtI18n: {
    paths: {
      cs: '/pobocky/:slug',
      de: '/niederlassung/:slug',
      en: '/branches/:slug',
      sk: '/pobocky/:slug',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageBranchDetail,
  },
  mixins: [AppRouteMixin, ImageUrlMixin],
  async asyncData({ app, store, params, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }
    const data = {
      branch: store.dispatch('branch/LOAD_BRANCH_BY_SLUG', { slug: params.slug }),
    }
    const response = await Promise.allValues(data)
    if (!response.branch) {
      return app.$pageNotFound({ slug: params.slug })
    }
    store.commit('locale/SET_CANONICALS', {
      canonicalSlugs: get(response, 'branch.page_meta.canonical_slugs', []),
    })
    return response
  },
}
export default PAGE
</script>
